import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'anoFileName'
})
export class AnoFileNamePipe implements PipeTransform {

  transform(filename: string): string {
    return filename.toString().replace('.pdf', '') + '-anonymised.pdf';
  }

}
